/**
 * Image API Funktionen
 */

import { apiClient } from '../api-client';
import type { Image } from '@/types';

// ===========================================
// IMAGE DETAILS
// ===========================================

/**
 * Einzelnes Bild mit Details laden
 */
export async function getImageDetails(imageId: string): Promise<{ success: boolean; image: Image }> {
  const response = await apiClient.get(`/api/workspace/images/${imageId}`);
  return response.data;
}

// ===========================================
// IMAGE ACTIONS
// ===========================================

/**
 * Bild löschen
 */
export async function deleteImage(imageId: string): Promise<{ success: boolean; message: string }> {
  const response = await apiClient.delete(`/api/workspace/images/${imageId}`);
  return response.data;
}

/**
 * Bild veröffentlichen
 */
export async function publishImage(imageId: string): Promise<{
  success: boolean;
  message: string;
  public_url?: string;
  in_showcase?: boolean;
  reward?: number;
}> {
  const response = await apiClient.post(`/api/workspace/images/${imageId}/publish`, {
    confirmed: true,
  });
  return response.data;
}

/**
 * Publish-Status prüfen
 */
export async function getImagePublishStatus(imageId: string): Promise<{
  success: boolean;
  is_published: boolean;
  public_url: string | null;
  can_publish: boolean;
  sharing_disabled: boolean;
}> {
  const response = await apiClient.get(`/api/image/${imageId}/publish-status`);
  return response.data;
}

/**
 * Bild downloaden (gibt Blob zurück)
 */
export async function downloadImage(imageId: string): Promise<Blob> {
  const response = await apiClient.get(`/api/workspace/images/${imageId}/download`, {
    responseType: 'blob',
  });
  return response.data;
}

/**
 * Bild regenerieren (neu generieren mit gleichen Parametern)
 */
export async function regenerateImage(imageId: string): Promise<{
  success: boolean;
  image_id?: string;
  credits_remaining: number;
  message?: string;
}> {
  const response = await apiClient.post(`/api/workspace/images/${imageId}/regenerate`);
  return response.data;
}

/**
 * Bildvariation generieren
 */
export async function generateVariation(imageId: string): Promise<{
  success: boolean;
  image_id?: string;
  credits_remaining: number;
  message?: string;
}> {
  const response = await apiClient.post(`/api/workspace/images/${imageId}/variation`);
  return response.data;
}

/**
 * Proxy-URL für Bild abrufen
 */
export async function getImageUrl(imageId: string): Promise<{
  success: boolean;
  url: string;
  is_public: boolean;
}> {
  const response = await apiClient.get(`/api/image/${imageId}/url`);
  return response.data;
}





